import { Component, EventEmitter, Input, Output, OnInit } from '@angular/core';

import { IMultiSelectOption, IMultiSelectSettings, IMultiSelectTexts } from 'ngx-bootstrap-multiselect';
import { pedidoStatusAmostra } from '../pedido-status-amostra';
import { PedidoStatusAmostraPipe } from '../pipes';

@Component({
    selector: 'sgt-pedido-status-amostra-multiselect',
    templateUrl: './pedido-status-amostra-multiselect.component.html',
    styleUrls: ['./pedido-status-amostra-multiselect.component.less']
})
export class PedidoStatusAmostraMultiselectComponent implements OnInit {
    /** Status das amostras selecionados */
    @Input() statusAmostras: number[];
    /** Ao alterar a seleção dos status das amostras */
    @Output() statusAmostrasChange = new EventEmitter<number[]>();

    @Input() disabled = false;

    // Settings
    settings: IMultiSelectSettings = {
        enableSearch: true,
        containerClasses: 'container-multiselect container-multiselect-pedido-status-amostra',
        showCheckAll: true,
        showUncheckAll: true,
        dynamicTitleMaxItems: 0,
        fixedTitle: true,
    }
    // Texts
    texts: IMultiSelectTexts = {
        checkAll: 'Selecionar todos',
        uncheckAll: 'Limpar',
        checked: 'status selecionado',
        checkedPlural: 'status selecionados',
        searchPlaceholder: 'Pesquisar...',
        defaultTitle: 'Status',
        allSelected: 'Todos selecionados',
        searchEmptyResult: 'Nenhum status encontrado',
        searchNoRenderText: 'Digite para pesquisar'
    }
    // Options
    options: IMultiSelectOption[];

    constructor(private pedidoStatusAmostraPipe: PedidoStatusAmostraPipe) { }

    ngOnInit() {
        this.create();
    }

    /** Cria os status das amostras para o multiselect */
    private create() {
        this.options = [];
        const selects: IMultiSelectOption[] = [];
        pedidoStatusAmostra.forEach(statusAmostra => {
            selects.push({
                id: statusAmostra.id,
                name: this.pedidoStatusAmostraPipe.transform(statusAmostra.id)
            });
        });
        this.options = selects;
    }

    /** Ao alterar a seleção dos status das amostras */
    onChange() {
        this.statusAmostrasChange.emit(this.statusAmostras);
    }
}
